// React for Website
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
//outsource
import { Row, Col, List, Card, Space, Button, Popconfirm, message } from "antd";
import { BsPersonCircle } from "react-icons/bs";
import { FiEdit2 } from "react-icons/fi";
import moment from "moment";
//components
import "./../style.css";
import BranchStaffListingRemove from "./component/branch_staff_listing_remove";
import BranchStaffListingActive from "./component/branch_staff_listing_active";
//redux
import { useDispatch } from "react-redux";
import { updateStaff } from "../../../store/staff/staff.action";
import BranchStaffListingInActive from "./component/branch_staff_listing_inactive";

const BranchStaffListing = ({ data, staffs }) => {
  // -------------------------- VAR --------------------------
  const navigate = useNavigate();

  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------
  const toggleActive = (staff) => {
    const active = staff?.active || false;

    const update = {
      active: !active,
    };

    if (staff) {
      setLoading(true);
      dispatch(
        updateStaff({ staff, update }, (response) => {
          if (response.status === 200) {
            message.success(`The User was ${active ? "Deactived" : "Active"}`);
          } else {
            message.error(response.data || "Error! Please try again");
          }
          setLoading(false);
        })
      );
    }
  };

  const navigateToEdit = (item) => {
    const href = `/branchs/detail/${item?.branch}/staff/${item?.id}`;
    navigate(href);
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const renderCardStaff = (item) => {
    const name = item?.fullName || "";
    const date = item?.startAt || "";
    const mobile = item?.mobile || "";
    const email = item?.email || "";
    const id = item?.id || "";
    const active = item?.active || false;

    return (
      <Card style={{ margin: "10px 0px" }} key={id}>
        <Row style={{ display: "flex", alignItems: "center" }}>
          <Col span={2}>
            <BsPersonCircle
              style={{ color: !active ? "#c0c0c0" : "" }}
              size={40}
            />
          </Col>
          <Col span={16}>
            <Row>
              <Col span={24}>
                <b style={{ fontSize: 20, color: !active ? "#c0c0c0" : "" }}>
                  {name}
                </b>{" "}
                <span
                  style={{ marginLeft: 10, color: !active ? "#c0c0c0" : "" }}
                >
                  (Created at {date})
                </span>
              </Col>
              <Col style={{ color: !active ? "#c0c0c0" : "" }} span={24}>
                <span>
                  Telephone: <strong>{mobile}</strong>
                </span>
                <span style={{ marginLeft: 10 }}>
                  Email: <strong>{email}</strong>
                </span>
              </Col>
            </Row>
          </Col>
          <Col align="right" span={6}>
            <Space>
              {/* {renderGroupButton(item)} */}
              {renderEditButton(item)}
              {item?.active
                ? renderInactiveButton(item)
                : renderActiveButton(item)}
              {renderRemoveButton(item)}
            </Space>
          </Col>
        </Row>
      </Card>
    );
  };

  // const renderGroupButton = (item) => {
  //   if (item?.active) {
  //     return (
  //       <>
  //         <Button
  //           loading={loading}
  //           className="width-100px"
  //           icon={
  //             <span className="anticon">
  //               <FiEdit2 />
  //             </span>
  //           }
  //           type="default"
  //           onClick={() => navigateToEdit(item)}
  //         >
  //           Edit
  //         </Button>
  //         <Popconfirm
  //           title="Are you sure to deactive this staff?"
  //           onConfirm={() => toggleActive(item)}
  //         >
  //           <Button
  //             loading={loading}
  //             style={{ backgroundColor: "red", border: 0, color: "white" }}
  //             type="primary"
  //             className="width-100px"
  //           >
  //             Inactive
  //           </Button>
  //         </Popconfirm>
  //       </>
  //     );
  //   } else {
  //     return (
  //       <>
  //         <Button
  //           loading={loading}
  //           className="width-100px"
  //           icon={
  //             <span className="anticon">
  //               <FiEdit2 />
  //             </span>
  //           }
  //           type="default"
  //           onClick={() => navigateToEdit(item)}
  //         >
  //           Edit
  //         </Button>
  //         <Popconfirm
  //           title="Are you sure to active this staff?"
  //           onConfirm={() => toggleActive(item)}
  //         >
  //           <Button
  //             loading={loading}
  //             className="width-100px"
  //             style={{ backgroundColor: "green", border: 0, color: "white" }}
  //             type="default"
  //           >
  //             Active
  //           </Button>
  //         </Popconfirm>
  //       </>
  //     );
  //   }
  // };

  // remove staff
  const renderRemoveButton = (item) => {
    return (
      <BranchStaffListingRemove
        item={item}
        loading={loading}
        setLoading={setLoading}
      />
    );
  };

  // edit button
  const renderEditButton = (item) => {
    return (
      <Button
        loading={loading}
        className="width-100px"
        icon={
          <span className="anticon">
            <FiEdit2 />
          </span>
        }
        type="default"
        onClick={() => navigateToEdit(item)}
      >
        Edit
      </Button>
    );
  };
  // active button
  const renderActiveButton = (item) => {
    return (
      <BranchStaffListingActive
        item={item}
        loading={loading}
        setLoading={setLoading}
      />
    );
  };

  // inactive button
  const renderInactiveButton = (item) => {
    return (
      <BranchStaffListingInActive
        item={item}
        loading={loading}
        setLoading={setLoading}
      />
    );
  };
  // -------------------------- MAIN --------------------------
  const converted = refineData(data, staffs);
  // console.log("converted", converted);
  return (
    <List
      grid={{ column: 1 }}
      itemLayout="vertical"
      dataSource={converted || []}
      renderItem={(item) => renderCardStaff(item)}
    />
  );
};

export default BranchStaffListing;

const refineData = (data, staffs) => {
  const newData = data?.map((item) => {
    const fullName = `${item?.firstName} ${item?.lastName}`;
    const startAt =
      item?.createAt && moment(item?.createAt?.toDate()).format("DD MMM YYYY");
    const mobile = item?.phone || "";
    const email = item?.email || "";
    const id = item?.id;
    const detail = staffs?.find((item) => item?.staff === id) || null;
    const active = detail ? detail?.active : false;
    const branch = detail ? detail?.branch : "";
    const staffId = detail ? detail?.id : "";
    const userId = detail ? detail?.staff : "";
    console.log({ data });
    return {
      id,
      fullName,
      startAt,
      mobile,
      email,
      active,
      staffId,
      branch,
      userId,
    };
  });

  return newData;
};
